import PropTypes from "prop-types";

import CirclePlay from "assets/svg/circle_play.svg";
import ViewAr from "assets/svg/view_ar.svg";

import styles from "./styles.module.css";

const ImageThumbnail = ({ imageUrl, type, onClick, alt }) => {
  const renderOverlay = () => {
    if (type === "video") return <CirclePlay />;
    if (type === "3d") return <ViewAr />;
    return null;
  };
  return (
    <div className={styles.wrap} onClick={onClick}>
      <img src={imageUrl} alt={alt} className={styles.image} />
      <div className={styles.cardOverlay}>{renderOverlay()}</div>
    </div>
  );
};

ImageThumbnail.propTypes = {
  imageUrl: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  alt: PropTypes.string,
};

export default ImageThumbnail;
